export default {
      id: "menu-close-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#menu-close",
      toString: function () {
        return this.url;
      }
    }